import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import authReducer, { resetAuth } from './auth/authSlice';
import userReducer, { resetUser } from './user/userSlice';
import reportReducer, { resetReport } from './report/reportSlice';
import reportV2Reducer, { resetReport as resetReportV2 } from './reportV2/reportV2Slice';
import dashboardReducer, { resetDashboard } from './dashboard/dashboardSlice';
import subscriptionReducer, {
  resetSubscription
} from './subscriptions/subscriptionSlice';
import utilsReducer, { resetUtils } from './utilts/utilsSlice';
import batchProcessorReducer, {
  resetBatchProcessor
} from './batchProcessor/batchProcessorSlice';
import gpsReducer, { resetGPS } from './gps/gpsSlice';
import staffContactsReducer, {
  resetStaffContacts
} from './staff-contacts/staffContactsSlice';
import learningResourcesReducer, {
  resetLearningResources
} from './learning-resources/learningResourcesSlice';
import apiMiddleware from './apiMiddleware';

const resetActions = {
  auth: resetAuth,
  user: resetUser,
  report: resetReport,
  reportV2: resetReportV2,
  dashboard: resetDashboard,
  utils: resetUtils,
  subscription: resetSubscription,
  bacthProcessor: resetBatchProcessor,
  gps: resetGPS,
  staffContacts: resetStaffContacts,
  learningResources: resetLearningResources
};

export const resetStore = () => (dispatch) => {
  Object.values(resetActions).forEach((resetAction) => dispatch(resetAction()));
};

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    report: reportReducer,
    reportV2: reportV2Reducer,
    dashboard: dashboardReducer,
    utils: utilsReducer,
    subscription: subscriptionReducer,
    batchProcessor: batchProcessorReducer,
    gps: gpsReducer,
    staffContacts: staffContactsReducer,
    learningResources: learningResourcesReducer
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(apiMiddleware);
  }
});

// // TODO replace useDispatch,useSelector with useAppDispatch,useAppSelector hook everywhere
export type RootState = ReturnType<typeof store.getState>;
export type State = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<State> = useSelector;
export interface StoreMethods {
  dispatch: AppDispatch;
  state: RootState;
  rejectValue: string;
}
